import { finectAPI } from '@finect/front-utils/finectAPI';
export var postlike = function postlike(id) {
  return finectAPI({
    version: 'v4',
    path: "users/me/likes",
    method: 'POST',
    body: {
      type: 'review',
      id: id
    }
  });
};
export var deleteLike = function deleteLike(id) {
  return finectAPI({
    version: 'v4',
    path: "users/me/likes?type=review&id=".concat(id),
    method: 'DELETE'
  });
};